import { render, staticRenderFns } from "./importFees.vue?vue&type=template&id=14476af4&scoped=true&lang=pug"
import script from "./importFees.vue?vue&type=script&lang=js"
export * from "./importFees.vue?vue&type=script&lang=js"
import style0 from "./importFees.vue?vue&type=style&index=0&id=14476af4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14476af4",
  null
  
)

export default component.exports